// Google Analytics 4 (gtag) helpers. The gtag loader lives in public/index.html.
export const GA_ID = "G-KZ5XQ3WCER";

export function gaPageView(path) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function gaEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  window.gtag("event", name, clean);
}
